import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <>
      <div className="flex items-center gap-3" data-id="element-348">
        <div className="w-12 h-12 rounded-full bg-[#A855F7]/20 border border-[#A855F7]/40 flex items-center justify-center text-[#A855F7] font-black text-sm flex-shrink-0" data-id="element-349">
          {initials}
        </div>
        <div data-id="element-350">
          <div className="text-[#A855F7] text-sm" data-id="element-351">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-352">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-353">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-354">
        &quot;{quote}&quot;
      </p>
    </>;
}
export function TestimonialsSection() {
  return <>
      <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-355">
        <div className="max-w-5xl mx-auto" data-id="element-356">
          <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-357">
            ❤️ MÁS INSTRUCTORES QUE YA LO TIENEN
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-10" data-id="element-358">
            <TestimonialCard initials="CR" stars={5} quote="El Tomo de Flow transformó mis clases. Los alumnos me preguntan qué cambié — y es que ahora la clase tiene energía y estructura real." name="Cecilia R." location="Mendoza" level="MegaPack + Especialista" data-id="element-359" />
            <TestimonialCard initials="RM" stars={5} quote="Con el kit anti-cancelaciones bajé un 60% los huecos en la agenda. Los mensajes copy/paste los uso todos los días." name="Roberto M." location="Buenos Aires" level="Instructor de Pilates" data-id="element-360" />
            <TestimonialCard initials="SC" stars={5} quote="El tablero de progreso de 4 semanas es lo que más me agradecen los alumnos. En un mes — renovación casi del 100%." name="Sofía C." location="La Plata" level="Instructora de Pilates" data-id="element-361" />
            <TestimonialCard initials="PA" stars={5} quote="El Manual de Posturología me permitió subir mis precios un 40% sin que ningún alumno se fuera. El criterio clínico cambia todo." name="Pablo A." location="Neuquén" level="Instructor de Pilates" data-id="element-362" />
            <TestimonialCard initials="VL" stars={5} quote="El Tomo 4 de embarazo me llegó justo cuando recibí mi primera alumna en segundo trimestre. Lo seguí al pie de la letra. La alumna renovó y me mandó a su hermana." name="Valentina L." location="Rosario" level="Instructora de Pilates" data-id="element-363" />
            <TestimonialCard initials="DM" stars={5} quote="Los 300 cues del Bono 2 transformaron mi comunicación. Mis alumnos dicen que ahora entienden lo que hace su cuerpo. Eso antes no pasaba." name="Diego M." location="Córdoba" level="Instructor de Pilates" data-id="element-364" />
          </div>
        </div>
      </section>
    </>;
}